// Helpers for "this email already has an account" — Google, Apple and
// email/password must resolve to one Firebase user (and therefore one
// Firestore `users` doc). The pending OAuth credential is stashed here
// because it cannot live in React state across the second popup.

export function parseAccountExistsError(error) {
  if (!error || error.code !== 'auth/account-exists-with-different-credential') {
    return null;
  }
  return {
    needsLink: true,
    email: error.email || error.customData?.email || '',
  };
}

export function providerLabel(id) {
  switch (id) {
    case 'google.com':
      return 'Google';
    case 'apple.com':
      return 'Apple';
    case 'password':
      return 'email and password';
    default:
      return id || 'another method';
  }
}

// Sign-in methods the member can use to unlock the existing account,
// excluding the one they just tried (that credential is the one we
// will attach after they prove they own the original login).
export function methodsForLinkingModal({ newProvider } = {}) {
  return [
    { id: 'google.com', label: 'Google' },
    { id: 'apple.com', label: 'Apple' },
    { id: 'password', label: 'email and password' },
  ].filter((m) => m.id !== newProvider);
}

let pendingLink = null;

export function stashPendingLink({ email, credential, newProvider }) {
  pendingLink = { email: email || '', credential: credential || null, newProvider: newProvider || null };
  return pendingLink;
}

export function getPendingLink() {
  return pendingLink;
}

export function clearPendingLink() {
  pendingLink = null;
}
